import { faCheckCircle, faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import {
	faBorderAll,
	faEyeSlash,
	faFile,
	faHistory,
	faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, Card, Nav, Tab, Table, Badge, Button } from "@themesberg/react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { PROPERTY_REDUCER_UPDATE_PROPERTY_STATUS } from "src/app/common/constants";
import { PropertyContext } from "src/app/contexts/PropertyContext";
import { routesPath } from "src/app/routes";
import AllProperties from "./property-list/AllProperties";
import ApprovedProperties from "./property-list/ApprovedProperties";
import DraftProperties from "./property-list/DraftProperties";
import HiddenProperties from "./property-list/HiddenProperties";
import PendingProperties from "./property-list/PendingProperties";
import RejectedProperties from "./property-list/RejectedProperties";

const Properties = () => {
	const { propertyData, setPropertyDataDispatch, getAllPropertyData } =
		useContext(PropertyContext);
	const [activeTab, setActiveTab] = useState("all");

	const navigate = useNavigate();

	console.log(propertyData);

	const handlePendingPropertyAction = (btnType, propertyId) => {
		setPropertyDataDispatch({
			type: PROPERTY_REDUCER_UPDATE_PROPERTY_STATUS,
			data: {
				id: propertyId,
				new_status: btnType,
			},
			loading: true,
			loading_message: "Update property status",
		});

		setActiveTab(btnType);
	};

	useEffect(() => {
		/* setPropertyDataDispatch({
			type: PROPERTY_REDUCER_GET_ALL_PROPERTY,
			loading: true,
			loading_message: "Loading properties data",
		}); */
		getAllPropertyData();
	}, []);

	return (
		<>
			<div className="d-flex justify-content-between align-items-center w-100">
				<Button
					variant="secondary"
					className="mt-4 text-dark"
					onClick={() => {
						navigate(routesPath.AddProperty.path);
					}}
				>
					<FontAwesomeIcon icon={faPlus} className="me-2" />
					Add Properties
				</Button>
			</div>
			<div className="py-4">
				<Card border="light" className="shadow-sm">
					<Card.Body>
						<Tab.Container
							defaultActiveKey="all"
							activeKey={activeTab}
							onSelect={(key) => setActiveTab(key)}
						>
							<Row>
								<Col lg={12}>
									<Nav className="nav-tabs">
										<Nav.Item>
											<Nav.Link eventKey="all" className="mb-sm-3 mb-md-0">
												<FontAwesomeIcon
													icon={faBorderAll}
													className="me-2"
												/>
												All
											</Nav.Link>
										</Nav.Item>
										<Nav.Item>
											<Nav.Link
												eventKey="pending"
												className="mb-sm-3 mb-md-0"
											>
												<FontAwesomeIcon
													icon={faHistory}
													className="me-2"
												/>
												Pending
											</Nav.Link>
										</Nav.Item>
										<Nav.Item>
											<Nav.Link
												eventKey="approved"
												className="mb-sm-3 mb-md-0"
											>
												<FontAwesomeIcon
													icon={faCheckCircle}
													className="me-2"
												/>
												Accepted
											</Nav.Link>
										</Nav.Item>
										<Nav.Item>
											<Nav.Link
												eventKey="rejected"
												className="mb-sm-3 mb-md-0"
											>
												<FontAwesomeIcon
													icon={faTimesCircle}
													className="me-2"
												/>
												Rejected
											</Nav.Link>
										</Nav.Item>

										<Nav.Item>
											<Nav.Link eventKey="hidden" className="mb-sm-3 mb-md-0">
												<FontAwesomeIcon
													icon={faEyeSlash}
													className="me-2"
												/>
												Hidden
											</Nav.Link>
										</Nav.Item>

										<Nav.Item>
											<Nav.Link eventKey="draft" className="mb-sm-3 mb-md-0">
												<FontAwesomeIcon icon={faFile} className="me-2" />
												Draft
											</Nav.Link>
										</Nav.Item>
									</Nav>
								</Col>
								<Col lg={12}>
									<Tab.Content>
										<Tab.Pane eventKey="all" className="py-4">
											{<AllProperties propertyData={propertyData} />}
										</Tab.Pane>
										<Tab.Pane eventKey="pending" className="py-4">
											{
												<PendingProperties
													propertyData={propertyData}
													handlePendingPropertyAction={
														handlePendingPropertyAction
													}
												/>
											}
										</Tab.Pane>
										<Tab.Pane eventKey="approved" className="py-4">
											{
												<ApprovedProperties
													propertyData={propertyData}
													handlePendingPropertyAction={
														handlePendingPropertyAction
													}
												/>
											}
										</Tab.Pane>
										<Tab.Pane eventKey="rejected" className="py-4">
											{
												<RejectedProperties
													propertyData={propertyData}
													handlePendingPropertyAction={
														handlePendingPropertyAction
													}
												/>
											}
										</Tab.Pane>
										<Tab.Pane eventKey="hidden" className="py-4">
											{
												<HiddenProperties
													propertyData={propertyData}
													handlePendingPropertyAction={
														handlePendingPropertyAction
													}
												/>
											}
										</Tab.Pane>
										<Tab.Pane eventKey="draft" className="py-4">
											{
												<DraftProperties
													propertyData={propertyData}
													handlePendingPropertyAction={
														handlePendingPropertyAction
													}
												/>
											}
										</Tab.Pane>
									</Tab.Content>
								</Col>
							</Row>
						</Tab.Container>
					</Card.Body>
				</Card>
			</div>
		</>
	);
};

export default Properties;
